import { Injectable } from '@angular/core';
import { SetShutDownTrackerRequest } from 'emr-ng-shared';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Shipment } from './shipment.model';

@Injectable()
export abstract class ShutdownTrackerPopup {
    abstract OpenShutdownTrackerConfirmation(request: SetShutDownTrackerRequest, isListViewAction: boolean, shipment: Shipment, closePopupOnSuccess?: BsModalRef): void;
}
